<template><div><h1 id="spendeneingang-nach-zeitraum" tabindex="-1"><a class="header-anchor" href="#spendeneingang-nach-zeitraum"><span>Spendeneingang nach Zeitraum</span></a></h1>
<p>Spendeneingang nach Zeitraum — Listet Spendenumsätze nach Ereignispositionen aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung zeigt die Spendenumsätze in einem bestimmten Zeitraum. Die Umsätze werden pro Ereignisposition einzeln ausgewiesen (pro Ereignis). Eingrenzung über Datum des Spendeneingangs und Mindest-Spendenumsatz pro Ereignisposition.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Spendeneingang nach Zeitraum</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Spendeneingang von Datum</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>Spendeneingang bis Datum</dt>
<dd>leer = unbegrenzt, inklusive</dd>
<dt>nur Spenden mit Mindestumsatz</dt>
<dd>kumulativer Spendenumsatz pro Ereignisposition grösser / gleich..., leer = alle Ereignispositionen werden gezeigt</dd>
<dt>Ausgabe</dt>
<dd>Standard (Drucker: A4-Portrait)</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>ENr.</td>
<td>Ereignisnummer</td>
</tr>
<tr>
<td>EP</td>
<td>Ereignispositionsnummer</td>
</tr>
<tr>
<td>Bezeichnung</td>
<td>Beichnung der Ereignisposition</td>
</tr>
<tr>
<td>Anzahl</td>
<td>Anzahl der Spendeneingänge der Ereignisposition</td>
</tr>
<tr>
<td>Betrag</td>
<td>Kumulativer Spendenumsatz pro Ereignisposition</td>
</tr>
</tbody>
</table>
<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Datenausgabe                                03.10.1998 10:33:10 pav  Seite     0</span>
<span class="line"></span>
<span class="line">von Datum 01.01.1998   bis Datum 01.09.1998   mit Mindestumsatz       50.00</span>
<span class="line"></span>
<span class="line">ENr. EP Bezeichnung                                         Anzahl       Betrag</span>
<span class="line">---- -- --------------------------------------------- ------------ ------------</span>
<span class="line">1005 00 Unbekannt                                             1.00       100.00</span>
<span class="line">1005 91 # Unbekannt 1991                                      3.00       300.00</span>
<span class="line">1005 97 # Unbekannt 1997                                      2.00       200.00</span>
<span class="line">1031 01 MJ: ESR MB 1.94d                                      7.00       505.00</span>
<span class="line">1034 00 ---                                                  14.00       195.00</span>
<span class="line">1034 01 Gr. d                                                 6.00        76.00</span>
<span class="line">9996 00 ---                                                  23.00     9,153.00</span>
<span class="line">.</span>
<span class="line">.</span>
<span class="line"></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div><p>Auf das Ereignis 1031.01 wurden 7 Spendeneinzahlungen verbucht, im Gesamtwert von Fr. 505.--.</p>
</div></template>


